import { Injectable } from '@angular/core';
import { TableService } from '@framewerx/kendo-angular-grid';
import { Project, ProjectService } from '../../../../advanced-bom-api';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * Handles projectgridservice for this module.
 */
export class ProjectGridService extends TableService<Project> {
  constructor(http: HttpClient, private clientService: ProjectService) {
    super(http, 'Project');
  }

  /**
   * Gets idurlpart for the current workflow.
   */
  getIdUrlPart(data: any | Project): string {
    if (data == null) {
      return '';
    }
    return `/${data.id}`;
  }

  /**
   * Handles cleanupitem for this module.
   */
  protected cleanupItem(dataItem: Project | any): any {
    delete dataItem.primaryCompany;
    return super.cleanupItem(dataItem);
  }

  /**
   * Handles add for this module.
   */
  add(data: any | Project): Observable<any> {
    return this.clientService.projectPost(this.cleanupItem(data));
  }

  /**
   * Handles delete for this module.
   */
  delete(data: any | Project): Observable<any> {
    return this.clientService.projectDelete(data.id);
  }

  /**
   * Handles update for this module.
   */
  update(data: any | Project): Observable<any> {
    return this.clientService.projectPatch(this.cleanupItem(data), data.id);
  }

  /**
   * Handles maptoobject for this module.
   */
  protected mapToObject(responseData: any | Project): Project {
    return responseData;
  }

  /**
   * Handles addmetadatatoobject for this module.
   */
  protected addMetaDataToObject(responseData: any): any {
    if (responseData.hasOwnProperty('changeOrders@odata.count')) {
      responseData['$metadata'].changes =
        responseData['changeOrders@odata.count'];
      delete responseData['changeOrders@odata.count'];
    }
    if (responseData.hasOwnProperty('breakdowns@odata.count')) {
      responseData['$metadata'].breakdowns =
        responseData['breakdowns@odata.count'];
      delete responseData['breakdowns@odata.count'];
    }
    if (responseData.hasOwnProperty('workTasks@odata.count')) {
      responseData['$metadata'].workTasks =
        responseData['workTasks@odata.count'];
      delete responseData['workTasks@odata.count'];
    }
    if (responseData.hasOwnProperty('tradeUnions@odata.count')) {
      responseData['$metadata'].tradeUnions =
        responseData['tradeUnions@odata.count'];
      delete responseData['tradeUnions@odata.count'];
    }
    if (responseData.hasOwnProperty('workPackages@odata.count')) {
      responseData['$metadata'].workPackages =
        responseData['workPackages@odata.count'];
      delete responseData['workPackages@odata.count'];
    }
    return super.addMetaDataToObject(responseData);
  }
}


